const primaryMain = '#FFC425';
const primaryMainOpacity = 'rgba(255,196,37, 0.5)';
const secondaryMain = '#492F92';
const secondaryMainOpacity = 'rgba(73,47,146, 0.5)';
const secondaryLight = '#604f91';
const tertiaryMain = '#FFC425';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
